export class mdlBindInfoReq_DH{
    public RegNo: number;
    public Insured_IdNo: string;
    public LangFlag: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlBindInfoReq_DH.ts